export enum GraphSensorType {
  WATER_LEVEL = 'water_level',
  TEMPERATURE = 'temp',
}
